/* global jQuery COMPONENTS */

COMPONENTS.ComponentAccordion = (function ($) {
  function ComponentAccordion () {
    this.$component = $('[data-ecs-component="component-accordion"]')
    this.accordion = $('[data-ecs-components-control="accordion"]')
  }

  ComponentAccordion.prototype.init = function () {
    if (this.accordion.length < 1) {
      // no accordion on page
      return false
    }
    this.accordion.accordion()
  }

  return ComponentAccordion
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentAccordion = new COMPONENTS.ComponentAccordion()
  COMPONENTS.componentAccordion.init()
})
